import React, { useEffect, useState } from 'react';
import './Divider.scss';
import hand from './assets/hand.svg';

export default function Divider({ visible, dividerClasses, preview = false }) {
  if (!visible) return <div />;

  const [previewClassName, setPreviewClassName] = useState('');
  useEffect(() => {
    if (preview) {
      setTimeout(() => {
        setPreviewClassName('active');
      }, 1500); // 1500 is animating hand set in SCSS

      setTimeout(() => {
        setPreviewClassName('');
      }, 4500); // 3000 is animating divider set in SyllableSegmentation.js + animating hand
    }
  }, [preview]);

  return (
    <div className={'divider ' + dividerClasses + ' ' + previewClassName}>
      <svg
        width="8"
        height="139"
        viewBox="0 0 8 139"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4V12C8 14.2091 6.20914 16 4 16C1.79086 16 0 14.2091 0 12V4Z"
          fill="#007A94"
        />
        <path
          d="M0 22C0 19.7909 1.79086 18 4 18C6.20914 18 8 19.7909 8 22V38C8 40.2091 6.20914 42 4 42C1.79086 42 0 40.2091 0 38V22Z"
          fill="#007A94"
        />
        <path
          d="M0 48C0 45.7909 1.79086 44 4 44C6.20914 44 8 45.7909 8 48V64C8 66.2091 6.20914 68 4 68C1.79086 68 0 66.2091 0 64V48Z"
          fill="#007A94"
        />
        <path
          d="M0 74C0 71.7909 1.79086 70 4 70C6.20914 70 8 71.7909 8 74V90C8 92.2091 6.20914 94 4 94C1.79086 94 0 92.2091 0 90V74Z"
          fill="#007A94"
        />
        <path
          d="M0 100C0 97.7909 1.79086 96 4 96C6.20914 96 8 97.7909 8 100V116C8 118.209 6.20914 120 4 120C1.79086 120 0 118.209 0 116V100Z"
          fill="#007A94"
        />
        <path
          d="M0 126C0 123.791 1.79086 122 4 122C6.20914 122 8 123.791 8 126V135C8 137.209 6.20914 139 4 139C1.79086 139 0 137.209 0 135V126Z"
          fill="#007A94"
        />
      </svg>

      {preview && <img src={hand} className="hand" />}
    </div>
  );
}
